import type { FC } from "react";
import classNames from "classnames";
import type { IconButtonProps } from "@mui/material";
import { IconButton } from "@mui/material";
import { PlusIcon } from "../../../../shared/icons/PlusIcon";
import styles from "../styles.module.css";

export const AddVersionButton: FC<IconButtonProps> = ({ ...props }) => {
  return (
    <IconButton
      className={classNames(styles["action-button"], {
        [styles["disabled"]]: props.disabled,
      })}
      {...props}
    >
      <PlusIcon />
    </IconButton>
  );
};
